import api from './api';

const positionService = {
  getPositionsByPlan: async (cutPlanId) => {
    try {
      const response = await api.get(`/cutting-positions/plan/${cutPlanId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar posições:', error);
      throw error;
    }
  },

  getPositionsByBoard: async (boardId) => {
    try {
      const response = await api.get(`/cutting-positions/board/${boardId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar posições:', error);
      throw error;
    }
  },

  getPositionById: async (id) => {
    try {
      const response = await api.get(`/cutting-positions/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar posição:', error);
      throw error;
    }
  },

  createPosition: async (data) => {
    try {
      const response = await api.post('/cutting-positions', data);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar posição:', error);
      throw error;
    }
  },

  createMultiplePositions: async (positions) => {
    try {
      const response = await api.post('/cutting-positions/multiple', { positions });
      return response.data;
    } catch (error) {
      console.error('Erro ao criar posições:', error);
      throw error;
    }
  },

  updatePosition: async (id, data) => {
    try {
      const response = await api.put(`/cutting-positions/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar posição:', error);
      throw error;
    }
  },

  updateCutStatus: async (id, cutStatus) => {
    try {
      const response = await api.put(`/cutting-positions/${id}/cut-status`, { cutStatus });
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar status do corte:', error);
      throw error;
    }
  },

  deletePosition: async (id) => {
    try {
      const response = await api.delete(`/cutting-positions/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar posição:', error);
      throw error;
    }
  },

  getPositionsWithLabels: async (cutPlanId) => {
    try {
      const response = await api.get(`/cutting-positions/plan/${cutPlanId}/with-labels`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar posições com etiquetas:', error);
      throw error;
    }
  }
};

export default positionService;
